import { persistingCounter } from 'bundles/common/utils/persistingCounter';

const COURSE_FRAME_M3_NAVIGATION_COUNT_KEY = 'course-frame-m3-navigation-count';
const MIN_M3_NAVIGATIONS_FOR_PENDO_GUIDE = 6;

const m3NavigationCounter = persistingCounter(COURSE_FRAME_M3_NAVIGATION_COUNT_KEY, 0);

/**
 * Gets the current M3 navigation count from localStorage.
 * Returns 0 if the value doesn't exist or is invalid.
 */
export const getM3NavigationCount = (): number => {
  return m3NavigationCounter.get();
};

/**
 * Checks if the M3 navigation count has met the threshold for showing the Pendo guide.
 */
export const hasMetM3NavigationThreshold = (): boolean => {
  return getM3NavigationCount() >= MIN_M3_NAVIGATIONS_FOR_PENDO_GUIDE;
};

/**
 * Increments the M3 navigation count in localStorage.
 * Fails silently if localStorage is not available.
 */
export const incrementM3NavigationCount = (): void => {
  if (!hasMetM3NavigationThreshold()) {
    m3NavigationCounter.increment();
  }
};
